import { useMutation, useQueryClient } from "@tanstack/react-query";
import { publicContentAPI } from "../../api/userApi";
import { queryKeys } from "../keys";

export interface CreatePublicContentPayload {
  description: string;
  hashtags: string[];
  type: string;
  price: number;
  files: File[];
  contentProviderAgreementAccepted: boolean;
}

export function useCreatePublicContentMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreatePublicContentPayload) => publicContentAPI(data, undefined),
    onSuccess: () => {
      // Інвалідуємо основні user-дані після створення поста
      queryClient.invalidateQueries({ queryKey: queryKeys.user });
    },
  });
}

